// extracted by mini-css-extract-plugin
export default {"Container":"ScreenItem_Container__HYX0z","Button":"ScreenItem_Button__fJ5xq","Image":"ScreenItem_Image__PJd2w"};